import Block from '@components/Layout/Block';
import styled from 'styled-components';
import { Props } from '../BlockMapper';
import { color, font, query } from '@design/templateFns';
import { Location } from '@icon/index';
import { FC, useEffect, useState } from 'react';
import { daysAgo } from '@util/daysAgo';
import { config } from '@cfg';

const ContentContainer = styled.div`
  margin-top: 32px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  a {
    text-decoration: none;
  }
  @media screen and (${query.atLeast('tablet')}) {
    margin-top: 128px;
  }
`;

const Header = styled.h1`
  ${font('headline-xl')};
  color: ${color('fg')};
  max-width: 743px;
  margin-left: auto;
  margin-right: auto;
  padding: 0;
  font-weight: 700;
  font-size: 32px;
  line-height: 120%;
  text-align: center;
  margin-bottom: 32px;
  @media screen and (${query.atLeast('tablet')}) {
    font-size: 40px;
  }
`;

const BarWrapper = styled.div`
  margin: 0 auto;
`;

const Bar = styled.div`
  margin: 28px auto;
  width: 1px;
  height: 118px;
  background-color: #e60000;
  @media screen and (${query.atLeast('tablet')}) {
    margin: 32px auto 64px;
  }
`;

const Text = styled.div`
  ${font('body-md-light')};
  color: ${color('gray5')};
  font-size: 14px;
  text-align: center;
  p {
    margin: 0;
  }
  @media screen and (${query.atLeast('tablet')}) {
    max-width: 624px;
    margin-left: auto;
    margin-right: auto;
    font-size: 16px;
  }
`;

const JobBlock = styled.div`
  padding: 32px 44px 28px;
  margin-bottom: 20px;
  border: 1px solid ${color('gray2')};
  display: flex;
  justify-content: space-between;
  color: ${color('gray4')};

  @media screen and (${query.below('desktop')}) {
    padding: 20px;
  }
  @media screen and (${query.below('tablet')}) {
    flex-direction: column;
    justify-content: space-evenly;
  }
  svg {
    margin-right: 3px;
  }
`;

const JobDetails = styled.div`
  .with-bullet:after {
    content: '';
    display: inline-block;
    width: 5px;
    height: 5px;
    border-radius: 5px;
    margin-left: 8px;
    margin-right: 8px;
    position: relative;
    bottom: 2px;
    background-color: ${color('gray2')};
  }
`;

const JobTiming = styled.div`
  ${font('body-md-light')};
  @media screen and (${query.below('tablet')}) {
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
  }
  @media screen and (${query.atLeast('desktop')}) {
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }
`;

const JobTitle = styled.span`
  ${font('subhead-lg')};
  color: ${color('fg')};
  margin-right: 32px;
  display: inline-block;
  width: 220px !important;
  @media screen and (${query.below('desktop')}) {
    ${font('subhead-md')};
    margin-right: 20px;
  }
  @media screen and (${query.below('tablet')}) {
    display: block;
    margin-bottom: 4px;
  }
`;

const JobType = styled.span`
  ${font('subhead-sm')};
  color: ${color('gray4')};
  min-width: 80px !important;
  display: inline-block;
`;

const JobLocationDesktop = styled.span`
  ${font('body-md-light')};
  margin-left: 35px;
  width: 100px !important;
  @media screen and (${query.below('desktop')}) {
    margin-left: 20px;
  }
  @media screen and (${query.below('tablet')}) {
    display: none;
  }
`;
const JobLocationMobile = styled.span`
  ${font('body-md-light')};
  display: none;
  @media screen and (${query.below('tablet')}) {
    display: inline-block;
  }
`;

const JazzHr: FC<Props> = (props) => {
  const { heading, subHeading } = props;
  const [jobListings, setJobListing] = useState<any[]>([]);

  useEffect(() => {
    getCurrentOpenings();
  }, []);

  const getCurrentOpenings = async () => {
    try {
      const baseUrlWithAPIKey = config.jazzHr.baseUrlWithApiKey!;
      const currentOpenings = await fetch(baseUrlWithAPIKey).then((res) => res.json());

      if (currentOpenings) {
        // API returns an array for multiple job openings
        if (Array.isArray(currentOpenings) && currentOpenings.length) {
          setJobListing(currentOpenings);
          // API returns an object for one job opening
        } else if (Object.keys(currentOpenings).length) {
          setJobListing([currentOpenings]);
        }
      }
    } catch (err) {
      console.log({ err });
    }
  };

  return (
    <>
      {jobListings && jobListings.length ? (
        <Block>
          <ContentContainer>
            {heading && <Header>{heading}</Header>}
            <Text>{subHeading}</Text>
            <Bar></Bar>
            {jobListings &&
              jobListings.map(function (job, index) {
                return (
                  <a href={`https://engelvoelkers.applytojob.com/apply/${job.id}`} target="_blank">
                    <JobBlock key={index}>
                      <JobDetails>
                        <JobTitle>{job.title}</JobTitle>
                        <JobType>{job.type}</JobType>
                        {/* <JobType>{job.level}</JobType> // Level not coming from the API  */}
                        <JobLocationDesktop>
                          <Location />
                          {job?.city}, {job.state}
                        </JobLocationDesktop>
                      </JobDetails>
                      <JobTiming>
                        <JobLocationMobile>
                          <Location />
                          {job?.city}, {job.state}
                        </JobLocationMobile>
                        {daysAgo(job.original_open_date)}
                      </JobTiming>
                    </JobBlock>
                  </a>
                );
              })}
          </ContentContainer>
        </Block>
      ) : (
        <></>
      )}
    </>
  );
};

export default JazzHr;
